import styled from '@emotion/styled';
import { gettext } from '@eventbrite/i18n';
import {
    getFormValidationAdornment,
    TextField,
    Typography,
} from '@eventbrite/marmalade';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { sanitizeText } from '../../../shared';

import { AutoCreateEventFormValues } from '../types';

export enum EventTitleFormFieldTestId {
    Field = 'AutoCreateEventTitleFormField',
}

export const EventTitleFormField = () => {
    const { control } = useFormContext<AutoCreateEventFormValues>();

    return (
        <>
            <Title>
                <Typography as="h2" color="neutral-900" variant="body-lg">
                    {gettext('What’s the name of your event?')}
                </Typography>
            </Title>
            <Subtitle>
                <Typography as="p" color="neutral-1000" variant="body-md">
                    {gettext(
                        'This will be your event’s title. Your title will be used to help create your event’s summary, description, category, and tags – so be specific!',
                    )}
                </Typography>
            </Subtitle>
            <Controller
                name="title"
                control={control}
                rules={{
                    required: {
                        value: true,
                        message: gettext('Title is required').toString(),
                    },
                }}
                render={({ field, fieldState: { error } }) => (
                    <TextField
                        autoComplete="off"
                        autoFocus
                        data-testid={EventTitleFormFieldTestId.Field}
                        hasError={!!error}
                        helperText={error && error.message}
                        id="auto-create-form-title"
                        label={gettext('Event title').toString()}
                        maxLength={75}
                        validationAdornment={getFormValidationAdornment({
                            hasError: !!error,
                        })}
                        {...field}
                        value={field.value || ''}
                        onChange={(value) => {
                            field.onChange({
                                target: { value: sanitizeText(value) },
                            });
                        }}
                        required
                    />
                )}
            />
        </>
    );
};

const Title = styled.div`
    margin-bottom: 8px;
`;

const Subtitle = styled.div`
    margin-bottom: 24px;
`;
